import React from 'react';
import SrtCaptionsComponent from '../components/SrtCaptions';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function SrtCaptions(props) {
  return (
    <AddonsContextConsumer>
      {({ constants: { CAPTIONS }, actions: { getCurrencySymbol } }) =>
      <SrtCaptionsComponent
        {...props}
        // $FlowFixMe Cannot call CAPTIONS because undefined [1] is not a function.
        SRT_CAPTIONS={CAPTIONS('SRT_CAPTIONS')}
        getCurrencySymbol={getCurrencySymbol} />}


    </AddonsContextConsumer>);

}

export default SrtCaptions;